import { render, staticRenderFns } from "./EditMerchantInfo.vue?vue&type=template&id=0b1422dc&scoped=true"
import script from "./EditMerchantInfo.vue?vue&type=script&lang=js"
export * from "./EditMerchantInfo.vue?vue&type=script&lang=js"
import style0 from "./EditMerchantInfo.vue?vue&type=style&index=0&id=0b1422dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1422dc",
  null
  
)

export default component.exports